
    angular.module('qkr')
        .factory('merchantUtilService', serviceUtilService);

    function serviceUtilService() {
        const categoriesConstant = {
            CHARITY: 'Charity',
            SCHOOL: 'School',
            UNIVERSITY: 'University',
            SUPPLIER: 'Supplier',
            SME_SUPPLIER: 'SME Supplier'
        };

        return {

            isCharity(businessCategory) {
                return businessCategory ? businessCategory.name === categoriesConstant.CHARITY : false;
            },

            isSingleOutlet(businessCategory) {
                return businessCategory ?
                    (businessCategory.name === categoriesConstant.SCHOOL ||
                        businessCategory.name === categoriesConstant.UNIVERSITY ||
                        businessCategory.name === categoriesConstant.SUPPLIER ||
                        businessCategory.name === categoriesConstant.SME_SUPPLIER) : false;
            }

        };
    }



// WEBPACK FOOTER //
// ./src/controllers/merchant/services/merchant.util.service.js